<template>

    <div :class="['section', { 'smallView': smallView }]">

        <div class="title is-5 has-text-left" v-show="showHeader==true">
            <lang :labelKey="labels.header"></lang>
        </div>

        <div class="commentsContainer">

            <!-- comment NEW -->
            <div class="columns NewComment" v-if="showInput">

                <template v-if="showAvatars == true">

                    <div class="column is-narrow">
                        <div class="avatar lazyImg lazy-img-fadein" v-lazy:background-image="getAvatar($store.getters.getUser)"></div>
                    </div>

                    <div class="column">
                        <div class="control">
                            <textarea :placeholder="labels.placeholder" class="textarea is-medium" type="text" v-model.trim="newComment.text" :readonly="isReadOnly"></textarea>
                        </div>
                        <button :class="[{'is-loading': isSaving, 'is-disabled': isReadOnly}, 'button is-pulled-right is-blue']" @click="addComment"><lang :labelKey="labels.addComment"></lang></button>
                    </div>

                </template>

                <template v-else>

                    <div class="column is-12">
                        <div class="control">
                            <textarea placeholder="Beitrag schreiben ..." class="textarea is-medium" type="text" v-model.trim="newComment.text" :readonly="isReadOnly"></textarea>
                        </div>
                        <button :class="[{'is-loading': isSaving, 'is-disabled': isReadOnly}, 'button is-pulled-right is-blue']" @click="addComment"><lang :labelKey="labels.addComment"></lang></button>
                    </div>

                </template>

            </div>


            <div v-else class="columns">

                <div class="column">
                    <alert icon="info-circle"><lang :labelKey="labels.noCommentsAllowed"></lang></alert>
                </div>

            </div>



            <!-- comment LIST -->
            <div class="commentList" v-if="thread.id != null">

                <!-- comment ROW -->
                <div v-for="post in commentsReversed" class="columns comment" :key="post">

                    <!-- with avatars -->
                    <template v-if="showAvatars == true">

                        <!-- avatar -->
                        <div class="column is-narrow">

                            <div class="avatar lazyImg lazy-img-fadein" v-lazy:background-image="getAvatar(post.author)"></div>

                        </div>

                        <!-- comment -->
                        <div class="column is-narrow">

                            <div class="commentHeader">
                                <span class="commentAuthor">{{ getAuthorName(post.author) }}</span><span class="commentDate">{{ post.created | formatDate }}</span>
                            </div>

                            <div class="commentBody" v-html="nl2br(post.comment)"></div>

                            <template v-if="['Administrator', 'Administrator JTM', 'Herba Chefredaktion'].indexOf(activeUser.userRole.name) > -1 || activeUser.id == post.author.id">

                                <pop-confirm :content="$t('CONFIRMATION-DELETE_COMMENT')" icon="question-circle-o" cancel-text="abbrechen" :on-ok="function() { deleteComment(post.id) }">
                                    <button class="deleteComment button is-small is-single is-light" title="Kommentar entfernen">
                                        <span class="icon is-small"><i class="icon-ak-entfernen-2"></i></span>
                                    </button>
                                </pop-confirm>

                            </template>

                        </div>

                    </template>


                    <!-- without avatars -->
                    <template v-else>

                        <div class="column is-12">

                            <div class="commentHeader">
                                <span class="commentAuthor">{{ getAuthorName(post.author) }}</span><span class="commentDate">{{ post.created | formatDate }}</span>
                            </div>

                            <div class="commentBody" v-html="nl2br(post.comment)"></div>

                            <template v-if="['Administrator', 'Administrator JTM', 'Herba Chefredaktion'].indexOf(activeUser.userRole.name) > -1 || activeUser.id == post.author.id">

                                <pop-confirm :content="$t('CONFIRMATION-DELETE_COMMENT')" icon="question-circle-o" cancel-text="abbrechen" :on-ok="function() { deleteComment(post.id) }">
                                    <button :class="[{'is-disabled': isReadOnly }, 'deleteComment button is-small is-single is-light']" title="Kommentar entfernen">
                                        <span class="icon is-small"><i class="icon-ak-entfernen-2"></i></span>
                                    </button>
                                </pop-confirm>

                            </template>

                        </div>

                    </template>


                </div>

            </div>

        </div> <!-- // commentsContainer -->


    </div>

</template>

<script>


export default {

    props: {
        threadID: {
            type: [Number, String],
            default: null
        },
        api: {
            type: String,
            default: ''
        },
        showHeader: {
            type: Boolean,
            default: true
        },
        smallView: {
            type: Boolean,
            default: false
        },
        threadFieldName: {
            type: String,
            default: 'thread'
        },
        showAvatars: {
            type: Boolean,
            default: true
        },
        labelPrefix: {
            type: String,
            default: ''
        },
        showInput: {
            type: Boolean,
            default: true
        },
        isReadOnly: {
            type: Boolean,
            default: false
        }
    },

    data: function() {

        return {
            isSaving: false,
            thread: {
                id: null,
                comments: []
            },
            newComment: {},
            labels: {
                header: 'COMMENTS_HEADER',
                addComment: 'BTN-ADD_COMMENT',
                placeholder: this.$t('PLACEHOLDER-POST_COMMENT'),
                noCommentsAllowed: this.$t('COMMENTS-NO_COMMENTS_ALLOWED')
            }


        }
    },

    created() {

        if(this.threadID != null) {
            this.fetchData();
        }

        if(this.labelPrefix != '') {
            this.labels.header = this.labelPrefix + '-' + 'COMMENTS_HEADER';
            this.labels.addComment = this.labelPrefix + '-' + 'BTN-ADD_COMMENT';
            this.labels.placeholder = this.$t(this.labelPrefix + '-' + 'PLACEHOLDER-POST_COMMENT');
            this.labels.noCommentsAllowed = this.labelPrefix + '-' + this.labels.noCommentsAllowed;
        }

    },

    mounted() {

    },

    computed: {

        commentsReversed() {
            return this.thread.comments.slice().reverse();
        }

    },

    methods: {

        getAvatar(author) {

            if(author.person && author.person.image != null && author.person.image.path) {
                return this.$config.assets + author.person.image.path + '/' + author.person.image.filename;
            } else {
                return require('../../../src/assets/img/no-avatar.png');
            }

        },

        getAuthorName(author) {

            if(author.person != null) {
                return author.person.fullName != null ? author.person.fullName : author.person.firstname + ' ' + author.person.lastname;
            } else {
                return author.username;
            }

            // return author.person != null && author.person.fullName != null ? author.person.fullName : author.username;
        },

        fetchData: function() {

            var self = this;

            this.axios.get(self.$config.api + 'thread/'+self.threadID+'?include=thread.comments,thread.user,comment.author,user.person,person.image&orderBy=comment.created%20ASC&showMetafields=1')

                .then(function(response) {
                    self.thread = response.data;
                }).catch(function(error) {
                    console.log('Error: ', error.message);
                    self.isLoading = false;
                });

        },

        addComment: function() {

            this.isSaving = true;

            if(!this.newComment.text || this.newComment.text.length < 3) {
                this.isSaving = false;
                this.$notify.open({content: this.$t('MSG-COMMENT_MUST_HAVE_3_CHARS_AT_LEAST'), type: 'warning'});
                return;
            }

            // there're no comments yet, so we've to start a completely new thread
            if(this.threadID == null) {

                this._createNewThread();

            // just make a normal comment post
            } else {

                this._postComment();

            }

        },

        deleteComment(id) {

            if(id === parseInt(id, 10)) {

                var self = this;

                this.axios.delete(self.$config.api + 'comment/'+id)
                    .then(function(response) {

                        self.thread.comments.forEach(function(comment, index) {

                            if(comment.id == id) {
                                self.thread.comments.splice(index, 1);
                                self.$notify.success({content: self.$t('MSG-SUCCESS-COMMENT_DELETED')});
                            }
                        })

                    }).catch(function(error) {

                        self.$notify.success({content: self.$t('MSG-ERROR-COMMENT_DELETED')});

                    });
            }

        },

        _createNewThread: function() {

            var self = this;
            var name = this.api.replace("/", "-");

            // make a new thread
            this.axios.post(self.$config.api + 'thread', { name: name } )
                .then(function(response) {

                    // update the corresponding pageElement
                    self._updatePageElement(self.api, response.data.id);

                }).catch(function(error) {

                    console.log('Error: ', error.message);
                    self.isSaving = false;

                });

        },

        _updatePageElement: function(api, threadID) {

            var self = this;
            var params = {};

            params[self.threadFieldName] = threadID;

            this.axios.put(this.$config.api + api, params)
                .then(function(response) {

                    // self.$emit('newThreadId', { threadID: threadID });
                    self.$emit('update:threadID', threadID);

                    self.threadID = threadID;
                    self.thread.id = threadID;

                    // finally post our comment into DB
                    self._postComment();


                }).catch(function(error) {

                    self.isSaving = false;
                    console.log('Error: ', error.message);

                });
        },

        _postComment: function() {

            var self = this;

            var newComment = {
                author_id: this.$store.getters.getUser.id,
                author: {
                    id: this.$store.getters.getUser.id,
                    username: this.$store.getters.getUser.username,
                    person: {
                        fullName: this.$store.getters.getUser.person != null ? this.$store.getters.getUser.person.fullName : this.$store.getters.getUser.username,
                        image: this.$store.getters.getUser.person.image != null ? this.$store.getters.getUser.person.image : ''
                    }
                },
                parent_id: 0,
                comment: this.newComment.text,
                created: new Date(),
                thread_id: this.thread.id
            }

            var saveComment = {
                author: this.$store.getters.getUser.id,
                parent: 0,
                comment: this.newComment.text,
                thread: this.thread.id
            }

            this.axios.post(this.$config.api + 'comment', saveComment)
                .then(function(response) {

                    // ad the comment_id to the newComment Array
                    newComment.id = response.data.id;

                    // push newly created comment into our thread.comments array
                    self.thread.comments.push(newComment);

                    // reset form field
                    self.newComment = {};

                    // set 'isSaving' flag to false
                    self.isSaving = false;

                }).catch(function(error) {
                    console.log('Error: ', error.message);
                    self.isSaving = false;
                });


        }

    }

}
</script>

<style scoped>

    .lazy-img-fadein[lazy=loading] {
        /* from: https://loading.io/ */
        background: transparent url('../../assets/img/ajax-spinner-ring.gif') no-repeat 50% 50% !important;
        background-size: contain !important;
        margin: auto;
    }

    .section {
        margin: 25px 0 !important;
        max-width: 100% !important;
    }
    .section.smallView {
        margin: 0;
    }

    .title.is-5 {
        margin: 0 0 45px 0;
        text-transform: uppercase;
    }

    .commentsContainer {
        margin: 0 1%;
    }
    .tab-pane .commentsContainer {
        margin: 0;
    }

    .avatar {
        background-repeat: no-repeat;
        background-position: 50% 0;
        /*background-size: contain;*/
        background-size: cover;
        width: 60px;
        height: 60px;
        border-radius: 50%;
        margin-right: 10px;
    }

    .newComment {
        margin-bottom: 50px !important;
    }


    /* single comment */
    .comment {
        margin-bottom: 25px !important;
    }
    .comment .avatar {
        background-repeat: no-repeat;
        background-position: 50% 0;
        /*background-size: contain;*/
        background-size: cover;
        width: 45px;
        height: 45px;
        border-radius: 50%;
        margin-right: 10px;
    }
    .comment .commentHeader {
        text-align: left;
    }
    .comment .commentHeader .commentAuthor {
        color: #000;
    }
    .comment .commentHeader .commentDate {
        margin-left: 5px;
        color: #aaa;
    }
    .comment .commentBody {
        margin: 10px 0 0 0;
        text-align: left;
        white-space: normal;
    }



    /* smallView stylings */
    .section.smallView {
        padding: 0;
        width: 100%;
        background-color: transparent !important;
    }
    .section.smallView .commentsContainer {
        margin: 0;
    }




    .smallView .newComment {
        margin-bottom: 25px;
    }
    .smallView .commentList .column {
        border-left: 1px solid #ddd;
    }
    .smallView .comment {
        position: relative;
        margin: 0 0 15px 0;
    }
    .smallView.section {
        margin: 10px 0 !important;
    }
    .smallView .avatar {
        width: 46px !important;
        height: 46px !important;
        border-radius: 23px;
    }



    .deleteComment {
        position: absolute;
        right: 0;
        top: 0;
        cursor: pointer;
        opacity: 0.2;
        transition: opacity .3s ease;
    }
    .deleteComment .icon.is-small {
        font-size: 12px;
        line-height: 20px;
    }
    .comment:hover .deleteComment {
        opacity: 1;
    }

    .columns.comment .column:first-child {
        flex: 0 1 0 !important;
    }
    .columns.comment .column:nth-child(2) {
        flex: 1 1 0;
        position: relative;
    }

    textarea.textarea {
        margin-bottom: 5px;
    }

    .section { margin: 15px 0; }
</style>
